import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import LoginPage         from './pages/LoginPage';
import LandingPage       from './pages/LandingPage';
import PatientAddingPage from './pages/PatientAddingPage';
import CasesPage         from './pages/CasesPage';
import ReportPage        from './pages/ReportPage';
import CombinedReportPage from './pages/CombinedReportPage.jsx';
import AdminPage         from './pages/AdminPage';

function RedirectToReport() {
  const { caseId } = useParams();
  return <Navigate to={`/cases/${caseId}/report`} replace />;
}

const PrivateRoute = ({ children, roles }) => {
  const { user, loading } = useAuth();

  if (loading) return (
    <div
      className="d-flex align-items-center justify-content-center vh-100"
      style={{ color: '#D03782' }}
    >
      <i className="fa fa-spinner fa-spin fa-2x" />
    </div>
  );

  if (!user) return <Navigate to="/login" replace />;

  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === 'superadmin' ? '/admin' : '/home'} replace />;
  }

  return children;
};

const HomeRedirect = () => {
  const { user, loading } = useAuth();

  if (loading) return (
    <div
      className="d-flex align-items-center justify-content-center vh-100"
      style={{ color: '#D03782' }}
    >
      <i className="fa fa-spinner fa-spin fa-2x" />
    </div>
  );

  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === 'superadmin' ? '/admin' : '/home'} replace />;
};

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>

        <ToastContainer
          position="top-right"
          autoClose={5500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnHover
          draggable={false}
          theme="colored"
        />

        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route index element={<HomeRedirect />} />
          <Route
            path="/admin"
            element={
              <PrivateRoute roles={['superadmin']}>
                <AdminPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/home"
            element={
              <PrivateRoute roles={['admin']}>
                <LandingPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/patients"
            element={
              <PrivateRoute roles={['superadmin', 'admin']}>
                <PatientAddingPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/cases"
            element={
              <PrivateRoute roles={['superadmin', 'admin']}>
                <CasesPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/cases/:caseId"
            element={
              <PrivateRoute roles={['superadmin', 'admin']}>
                <RedirectToReport />
              </PrivateRoute>
            }
          />
          <Route
            path="/cases/:caseId/report"
            element={
              <PrivateRoute roles={['superadmin', 'admin']}>
                <ReportPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/cases/:caseId/combined"
            element={
              <PrivateRoute roles={['superadmin', 'admin']}>
                <CombinedReportPage />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<HomeRedirect />} />
        </Routes>

      </BrowserRouter>
    </AuthProvider>
  );
}